export default __webpack_public_path__ + "static/andrii-boiko-867b3afb9a21a1d304043733beb7f473.png";